(function () {
  if (window.HpShowroomTracking) return;
  const inFlight = new Set();
  const shopify = window.Shopify;
  if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {});
  }

  function permitted() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy &&
      ['marketingAllowed', 'analyticsProcessingAllowed', 'saleOfDataAllowed'].every(
        method => typeof privacy[method] === 'function' && privacy[method]() === true));
  }

  window.HpShowroomTracking = {
    attach: function (namespace, themeId) {
      window.Cal.ns[namespace]('on', {
        action: 'bookingSuccessfulV2',
        callback: async function (event) {
          const data = event.detail && event.detail.data;
          if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'unpublished' &&
              new URLSearchParams(window.location.search).get('hp_tracking_debug') === '1') {
            console.info('[HP showroom] Cal result (no personal data)', {
              status: data && data.status,
              paymentRequired: data && data.paymentRequired,
              hasBookingId: Boolean(data && data.uid)
            });
          }
          const analytics = window.Shopify && window.Shopify.analytics;
          if (!data || typeof data.uid !== 'string' || !data.uid ||
              data.status !== 'ACCEPTED' || data.paymentRequired !== false ||
              !permitted() || !analytics || typeof analytics.publish !== 'function') return;
          if (inFlight.has(data.uid)) return;
          inFlight.add(data.uid);
          try {
            const digest = await window.crypto.subtle.digest('SHA-256',
              new TextEncoder().encode(data.uid));
            if (!permitted()) return;
            const eventId = 'hp-showroom-' + Array.from(new Uint8Array(digest),
              byte => byte.toString(16).padStart(2, '0')).join('');
            await analytics.publish('hp:showroom_confirmed', {
              event_id: eventId,
              theme_id: String(themeId),
              source: 'hp-showroom-cal-embed-v1',
              status: 'ACCEPTED'
            });
          } catch (error) {
            // Tracking must never interrupt booking or expose booking details.
            console.warn('[HP showroom] Conversion could not be queued.');
          } finally {
            inFlight.delete(data.uid);
          }
        }
      });
    }
  };
})();
